<template>
    <div> 
        <v-btn class="rounded-lg" elevation="0" color="#327d3c" @click="exportExcel()" :loading="loading">
            <span class="textBtn"><v-icon class="mr-1">mdi-microsoft-excel</v-icon>{{ $t('buttons.generate_excel_sheet') }}</span>
        </v-btn>
    </div>
</template>
<script> 
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
export default({
    data() {
        return {
            loading: false
        };
    },

    props: {
        resource: Array,
        patient: Object
    },

    methods: {
    exportExcel() {
        this.loading = true;

            if (!this.resource || !this.resource.length) {
                alert("Nenhum dado disponível!");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Exames');

            // cabeçalho
            worksheet.addRow([]);
            worksheet.addRow(['SISTRANS - Sistema de Gerenciamento de Doação e Transplante da Bahia']);
            worksheet.addRow([`Paciente: ${this.patient.name}`]);
            worksheet.addRow([`Gerado em: ${new Date().toLocaleString()}`]);
            worksheet.addRow([`Responsável: ${this.resource[0].users.name}`]);
            worksheet.addRow([]); 

           
            const sortedData = [...this.resource].sort((a, b) => new Date(a.date_exam) - new Date(b.date_exam));

            // extrair datas
            const dates = sortedData.map(item => {
                const d = new Date(item.date_exam);
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            });

            // campos de exames
            const exclude = ['id', 'donor_id', 'user_id', 'created_at', 'updated_at', 'users', 'date_exam', 'name'];
            const exams = Object.keys(sortedData[0]).filter(key => !exclude.includes(key));

            // exames traduzidos
            const nomesExames = {
                hb: 'Hemoglobina',
                glucose: 'Glicose',
                diuresis: 'Diurese',
                ht: 'Hematócrito',
                tp: 'Tempo de Protrombina',
                blood_products: 'Hemocomponentes',
                silly: 'Sódio Sérico',
                rni: 'RNI',
                vasoative_drugs: 'Drogas Vasoativas',
                canes: 'Cânulas',
                amylase: 'Amilase',
                antibiotics: 'Antibióticos',
                segmented: 'Segmentados',
                tgo: 'TGO',
                pa: 'Pressão Arterial',
                plts: 'Plaquetas',
                tgp: 'TGP',
                pam: 'Pressão Arterial Média',
                urea: 'Ureia',
                fosf: 'Fósforo',
                fc: 'Frequência Cardíaca',
                creat: 'Creatinina',
                gamagt: 'Gama GT',
                t_graus: 'Temperatura (°C)',
                na: 'Sódio',
                bil_total: 'Bilirrubina Total',
                bil_direta: 'Bilirrubina Direta',
                sat: 'Saturação O₂',
                k: 'Potássio',
                fio: 'FiO₂',
                ph: 'pH',
                po: 'pO₂',
                pco: 'pCO₂',
                sato2_pulmao: 'Saturação O₂ Pulmonar'
            };

            // linha de cabeçalho dos exames
            worksheet.addRow(['Exame', ...dates]);
            const headerRow = worksheet.lastRow;
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF327D3C' }
                };
                cell.font = { color: { argb: 'FFFFFFFF' }, bold: true };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });

            // linhas de exames
            exams.forEach(exam => {
                const row = [nomesExames[exam] || exam]; 
                sortedData.forEach(item => {
                    row.push(item[exam] !== null && item[exam] !== undefined ? item[exam] : '');
                });
                worksheet.addRow(row);
            });
 
            worksheet.columns.forEach(col => { col.width = 15; });
 
            setTimeout(() => {
                this.loading = false,
                // --- salvar Excel
                workbook.xlsx.writeBuffer().then(buffer => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'exames.xlsx');
                });
            }, 3000);
            
        } 
    } 
})
</script>
<style scoped>
.textBtn{
  color:#ffffff;
}
</style>